var _defs, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgConsentimiento(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: 136.418,
    height: 151.39,
    viewBox: "0 0 136.418 151.39",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".a{fill:#fff;}.b,.c,.e,.g{fill:none;}.b{stroke:#898b8d;stroke-width:2px;}.b,.e{stroke-linecap:round;}.c{stroke:#28a745;}.d{fill:#28a745;}.e,.g{stroke:#000;}.f{fill:#dc0f87;}.h{fill:#464646;font-size:10px;font-family:Barlow-SemiBold, Barlow;font-weight:600;letter-spacing:0.028em;}.i{filter:url(#a);}"), /*#__PURE__*/React.createElement("filter", {
    id: "a",
    x: 0,
    y: 0,
    width: 136.418,
    height: 151.39,
    filterUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("feOffset", {
    dy: 3,
    input: "SourceAlpha"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 3,
    result: "b"
  }), /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0.161
  }), /*#__PURE__*/React.createElement("feComposite", {
    operator: "in",
    in2: "b"
  }), /*#__PURE__*/React.createElement("feComposite", {
    in: "SourceGraphic"
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    transform: "translate(-14666 -8738)"
  }, /*#__PURE__*/React.createElement("g", {
    className: "i",
    transform: "matrix(1, 0, 0, 1, 14666, 8738)"
  }, /*#__PURE__*/React.createElement("path", {
    className: "a",
    d: "M5.995,0H112.423c5.566,0,5.995.511,5.995,6.177V127.213c0,5.667-.429,6.177-5.995,6.177H5.995C.429,133.39,0,132.88,0,127.213V6.177C0,.511.429,0,5.995,0Z",
    transform: "translate(9 6)"
  })), /*#__PURE__*/React.createElement("line", {
    className: "b",
    x2: 45.637,
    transform: "translate(14730.509 8815.098)"
  }), /*#__PURE__*/React.createElement("line", {
    className: "b",
    x2: 45.637,
    transform: "translate(14730.509 8825.625)"
  }), /*#__PURE__*/React.createElement("g", {
    transform: "translate(14694.459 8815.124)"
  }, /*#__PURE__*/React.createElement("path", {
    className: "c",
    d: "M0,0H18.85V18.85H0Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "d",
    d: "M8.237,15.689l-3.6-3.981L3.41,13.055l4.827,5.336L18.6,6.936,17.381,5.59Z",
    transform: "translate(-1.462 -2.397)"
  })), /*#__PURE__*/React.createElement("path", {
    className: "e",
    d: "M395.37,382.25c-5.457.5-11.409,10.913-6.449,12.4s8.433-3.968,8.433-3.968.5,4.961,1.984,3.968,2.906.707,2.055-2.693a21.188,21.188,0,0,0-2.055-5.385l6.307,8.078s-.284,5.245-2.268,4.678,0-7.371,2.268-8.646a50.623,50.623,0,0,0,5.669-4.11s-2.268,5.385,0,4.11a16.028,16.028,0,0,0,4.252-4.11v4.11s1.417,2.409,3.4,0,3.4.992,4.535,0",
    transform: "translate(14331.882 8469.3)"
  }), /*#__PURE__*/React.createElement("g", {
    transform: "translate(14716.151 8779.734)"
  }, /*#__PURE__*/React.createElement("path", {
    className: "f",
    d: "M14531,8913.5a70.479,70.479,0,0,0-7.286,6.358c-3.047,3.18-3.709,4.9-3.709,4.9s2.649,4.106,5.166,5.83,5.829,3.709,5.829,3.709a23,23,0,0,1,4.77-5.035c2.385-1.59,6.491-4.5,6.491-4.5a54.49,54.49,0,0,1-7.419-5.961C14531.657,8915.619,14531,8913.5,14531,8913.5Z",
    transform: "translate(-14513.642 -8913.5)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "g",
    d: "M14516.081,8942h-3.576l-4.5,1.352h31.264l-2.915-1.352h-3.444",
    transform: "translate(-14508.001 -8927.454)"
  })), /*#__PURE__*/React.createElement("text", {
    className: "h",
    transform: "translate(14719 8762)"
  }, /*#__PURE__*/React.createElement("tspan", {
    x: -36.821,
    y: 0
  }, "Consentimiento")), /*#__PURE__*/React.createElement("line", {
    className: "b",
    x2: 45.637,
    transform: "translate(14730.509 8835.153)"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgConsentimiento);
export default __webpack_public_path__ + "static/media/consentimiento.ad8b0c60da7777549f739d240cff8677.svg";
export { ForwardRef as ReactComponent };